// OK
import apiClient from "../plugins/axios-instance";
import Properties from "../properties";

const API_URL = "https://pelanggan." + Properties.DOMAIN_URL + "/api/v1";

export default class PelangganAPIService {
  constructor() {}
  static search = (input, limit, kolomUrut, desc, page) =>
    apiClient.get(
      API_URL +
        "/pelanggans/punya-alias/2/searching-pelanggan/" +
        input +
        "/kolom-urut/" +
        kolomUrut +
        "/desc/" +
        desc +
        "/limit/" +
        limit +
        "?page=" +
        page
    );
  static search2 = (input, limit, kolomUrut, desc, page) =>
    apiClient.get(
      API_URL +
        "/pencarian/pelanggan",
      {
        params: {
          punyaAlias: 2,
          input: input,
          kolomUrut: kolomUrut,
          desc: desc,
          limit: limit,
          page: page
        }
      }
    );
  static searchUltah = (bulan, hari, limit, page) =>
    apiClient.get(
      API_URL +
        "/pelanggans/bulan/" +
        bulan +
        "/hari/" +
        hari +
        "/limit/" +
        limit +
        "?page=" +
        page
    );
  static create = (kdToko, profil) =>
    apiClient.post(API_URL + "/pelanggans/toko/" + kdToko, profil);
    
  static editProfile = (alias, profil) =>
    apiClient.put(API_URL + "/pelanggans/alias/" + alias, profil);
    
  static editProfileKdCust = (kd_cust, profil) =>
    apiClient.put(API_URL + "/pelanggans/" + kd_cust, profil);
    
  static getAgamas = () =>
    apiClient.get(API_URL + "/agamas");
    
  static getPekerjaans = () =>
    apiClient.get(API_URL + "/pekerjaans");
    
  static resetUID = (alias, nik) =>
    apiClient.post(
      API_URL + "/pelanggans/reset-uid/alias/" + alias,
      { user_update: nik }
    );
    
  static getPelangganByAlias = (alias) =>
    apiClient.get(API_URL + "/pelanggans/kode-member/" + alias);
  
  // static getPelangganByKDCust = (kode) => {
  //   return apiClient.get(API_URL + "/pelanggans/" + kode);
  // }

  static generateAlias = () =>
    apiClient.get(API_URL + "/pelanggans/alias/new/J");
}
